import type { UserDto } from '@dispositio/shared';

/** Adresse des Profilfotos; der Stand in der Adresse sorgt dafür, dass ein neues Foto neu geladen wird. */
export const avatarUrl = (user: UserDto): string | null => (user.avatar ? `/api/auth/avatar?v=${encodeURIComponent(user.avatar)}` : null);

/** Profilfoto als Kreis; ohne Foto der erste Buchstabe der E-Mail-Adresse. Rein schmückend (die Beschriftung trägt der Knopf). */
export function Avatar({ user, size = 28 }: { user: UserDto | null | undefined; size?: number }) {
  const url = user ? avatarUrl(user) : null;
  const initial = (user?.email.trim()[0] ?? '?').toUpperCase();
  return (
    <span className="avatar" style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }} aria-hidden="true" data-testid="avatar" data-photo={url ? 'yes' : 'no'}>
      {url ? <img src={url} alt="" width={size} height={size} draggable={false} /> : initial}
    </span>
  );
}
